// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dac9a9b6","488":"edda780f"}[chunkId] + ".chunk.js";
};